<template>
<div  style="width: 100%;height: calc(100% - 200px) ;position: fixed;top: 150px; background-color: #F2F8FC;z-index: 2; " v-if="kong" >
    <div class="kong" >
        <img src="@/assets/kongyemian.png" alt="">
        <br>
        <br>
        暂无数据
    </div>
</div>
 

   
   
        <div class="installt">
            <div class="intext"> 分销码促销 </div>
            <div v-if="!kong" >
                <div class="addpoper">
                <el-date-picker class="choosedatas" v-model="choosedata" type="daterange" range-separator="-"
                    start-placeholder="" end-placeholder=" " @change="changedata" format="YYYY-MM-DD" />
            </div>
            </div>
          
        </div>
        
        <div class="fenmsg">
            <div class="fennub">

                <div class="fennubs">
                    <div class="nubtop">
                        分享人数
                    </div>
                    <div class="nubs">
                        <div class="zongnub">
                            <div>{{ shareNumberPageList.totalShareNumber }}</div>
                            <div class="zongbai">{{ zhang1.toFixed(2) }}%</div>
                        </div>
                        <div :id="'myEcharts1'" style="width: 170px;height: 70px;overflow: hidden;">

                        </div>
                    </div>
                </div>
                <div class="fennubs">
                    <div class="nubtop">
                        分销码营销订单
                    </div>
                    <div class="nubs">
                        <div class="zongnub">
                            <div>{{ shareNumberPageList.totalOrderNumber }}</div>
                            <div class="zongbai">{{ zhang2.toFixed(2) }}%</div>
                        </div>
                        <div :id="'myEcharts2'" style="width: 170px;height: 70px;overflow: hidden;">

                        </div>
                    </div>
                </div>
                <div class="fennubs">
                    <div class="nubtop">
                        分销码下单营业额(元)
                    </div>
                    <div class="nubs">
                        <div class="zongnub">
                            <div>{{ shareNumberPageList.totalAmount }}</div>
                            <div class="zongbai">{{ zhang3.toFixed(2) }}%</div>
                        </div>
                        <div :id="'myEcharts3'" style="width: 170px;height: 70px;overflow: hidden;">

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="fenlist">
            <div class="jilulist">
                <div class="jitop">
                    <div class="jitopa">分销码订单记录</div>
                    <div class="jitopb" @click="fenlist">查看明细</div>
                </div>

                <div class="riperpo">
                    <table>
                        <thead>
                            <tr style="background-color: #FAFAFA;">
                                <th style="width: 130px;">订单</th>
                                <th style="width: 130px;">买家</th>
                                <th style="width: 196px;">推广用户</th>
                                <th style="width: 196px;">推广金额（元）</th>
                                <!-- <th>具体操作</th> -->
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in orderPageList.orderLists">
                                <td style="padding-left: 26px;box-sizing: border-box;width: 300px;">
                                    <div class="libaomm">
                                        <div class="mmimg">
                                            <img :src="images(item.productImg[0])" alt="">
                                        </div>
                                        <div class="libaomms">
                                            <div class="imgname" :title="item.productName">{{ item.productName }}</div>
                                            <div class="imngnub">ID: {{ item.productId }}</div>
                                        </div>
                                    </div>
                                </td>
                                <td style="width: 130px;">

                                    {{ item.sellerName }}

                                </td>
                                <td style="width: 196px;">{{ item.sharerName }}</td>
                                <td style="width: 196px;"> {{ item.amount }} </td>
                                <!-- <td>1</td> -->
                            </tr>


                        </tbody>
                    </table>
                </div>



            </div>
            <div class="pailist">

                <div class="jitop">
                    <div class="jitopa">分销码排行</div>
                    <div class="jitopb" @click="getpai">查看明细</div>
                </div>
                <div class="riperpo">
                    <table>
                        <thead>
                            <tr style="background-color: #FAFAFA;">
                                <th style="width: 100px;">用户</th>
                                <th style="">分销商品数</th>
                                <th style="">获取佣金（元）</th>

                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in rankingPageList.rankingList">

                                <td style="padding-left: 20px">

                                    {{ item.sharerName }}

                                </td>
                                <td>{{ item.goodsNumber }}</td>
                                <td> {{ item.kickbackAmount }} </td>
                                <!-- <td>1</td> -->
                            </tr>

                        </tbody>
                    </table>
                </div>
                <div style="height: 62px;"></div>
                <div class="paixi">
                    查看全部内容
                </div>
            </div>
        </div>
   
</template>

<script setup>
import * as echarts from 'echarts';
import api from '@/api/api';
import images from '@/utils/images'

import { nextTick, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
const router = useRouter()
let nowdata = new Date()
let mextdata = new Date()
let startTime = ref('')
let endTime = ref('')
let kong = ref(false)
const choosedata = ref([nowdata, mextdata])
const changedata = (e) => {
    console.log('时间改变', e)
    if (e == null) {
        e = ['', '']
    }
    startTime.value = datahuan(e[0])
    endTime.value = datahuan(e[1])
    console.log(startTime.value)
    console.log(endTime.value)

    distributionCode()
}
const datahuan = (days) => {
    if (days) {
        const date = new Date(days);
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
    } else {
        return '暂无数据';
    }
}
let myChart
let chartData = ref({

    xAxis: {
        show: false,
        // data: ['A', 'B', 'C', 'D', 'E']
    },
    yAxis: {
        show: false
        // length: 3,

    },
    series: [
        {
            data: [],
            type: 'line',
            smooth: true,
            symbol: 'none',
            areaStyle: {
                color: '#69A5FF',
                opacity: 0.1
            }
        }
    ]
})
let myChart2
let chartData2 = ref({

    xAxis: {
        show: false,
        // data: ['A', 'B', 'C', 'D', 'E']
    },
    yAxis: {
        show: false
        // length: 3,

    },
    series: [
        {
            data: [],
            type: 'line',
            smooth: true,
            symbol: 'none',
            areaStyle: {
                color: '#69A5FF',
                opacity: 0.1
            }
        }
    ]
})
let myEcharts3
let chartData3 = ref({

    xAxis: {
        show: false,
        // data: ['A', 'B', 'C', 'D', 'E']
    },
    yAxis: {
        show: false
        // length: 3,

    },
    series: [
        {
            data: [],
            type: 'line',
            smooth: true,
            symbol: 'none',
            areaStyle: {
                color: '#69A5FF',
                opacity: 0.1
            }
        }
    ]
})
onMounted(() => {
    distributionCode()
})
let orderPageList = ref({})
let shareNumberPageList = ref([])
let rankingPageList = ref({})
let zhang1 = ref(0)
let zhang2 = ref(0)
let zhang3 = ref(0)
const distributionCode = async () => {
    let data = {
        endTime: endTime.value,
        interfaceType: 0,
        pageCount: 1,
        pageSize: 4,
        screenType: 0,
        startTime: startTime.value,
        storeId: 77,
    }
    const res = await api.distributionCode(data)
    console.log(res)
    if (res.success) {
        if (!res.data.orderPageList && !res.data.shareNumberData && !res.data.rankingPageList) {
            kong.value = true

        } else {
       
        orderPageList.value = res.data.orderPageList
        shareNumberPageList.value = res.data.shareNumberData

        rankingPageList.value = res.data.rankingPageList
        console.log('distributionCode', res.data)
        let perShareNumber = []
        let perOrderNumber = []
        let perAmount = []


        for (let a = 0; a < shareNumberPageList.value.shareNumberList.length; a++) {
            perShareNumber.push(shareNumberPageList.value.shareNumberList[a].perShareNumber)
            perOrderNumber.push(shareNumberPageList.value.shareNumberList[a].perOrderNumber)
            perAmount.push(shareNumberPageList.value.shareNumberList[a].perAmount)
        }
        chartData.value.series[0].data = perShareNumber
        chartData2.value.series[0].data = perOrderNumber
        chartData3.value.series[0].data = perAmount
        zhang1.value = growthRate(perShareNumber)
        zhang2.value = growthRate(perOrderNumber)
        zhang3.value = growthRate(perAmount)


        // let perShareNumber = res.data.shareNumberData.shareNumberList

        nextTick(() => {
            myChart = echarts.init(document.getElementById('myEcharts1'));
            myChart.setOption(chartData.value)
            myChart2 = echarts.init(document.getElementById('myEcharts2'));
            myChart2.setOption(chartData2.value)
            myEcharts3 = echarts.init(document.getElementById('myEcharts3'));
            myEcharts3.setOption(chartData3.value)
            // chartData()

        })
    }
    }
}
const growthRate = (array) => {
    let firstNonZeroIndex = 0;
    while (array[firstNonZeroIndex] === 0) {
        firstNonZeroIndex++;
    }

    const firstElement = array[firstNonZeroIndex];
    const lastElement = array[array.length - 1];

    const growthAmount = lastElement - firstElement;
    const growthRatePercent = (growthAmount / firstElement) * 100;

    return growthRatePercent;
}

const fenlist = () => {
    router.push('/home/fenxiao/fenlist')
}
const getpai = () => {
    router.push('/home/fenxiao/fenpai')

}
</script>

<style lang="scss" scoped>
::v-deep .choosedatas {
    width: 315px;
    height: 48px;
    background-color: #fff;
    --el-input-border-color: transparent;
    cursor: pointer;

    input {
        font-size: 16px;
        color: #718096;
        cursor: pointer;
    }

}

.kong {
    width: 201px;
    text-align: center;
    position: absolute;
    top: 50%;
    left: calc( 50% - 200px) ;
    // transition: translate(-100%, -50%);
    transform: translate(-50%, -50%); /* 使用transform属性来进行平移 */
    img {
        width: 100%;
    }
}

.installt {
    max-width: 1186px;
    display: flex;
    height: 50px;
    justify-content: space-between;
    align-items: center;

    .intext {
        font-size: 36px;
        font-weight: 400;
        color: #0A1629;
    }

    .addpoper {}
}

.fenmsg {
    width: 100%;

    .fennub {

        display: flex;
        // justify-content: space-between;
        margin-top: 43px;
        max-width: 1187px;
        justify-content: space-between;

        .fennubs {
            width: 367px;
            height: 144px;
            background: #FFFFFF;
            border-radius: 8px;
            margin-right: 25px;
            padding: 16px 40px 0 16px;
            box-sizing: border-box;

            .nubtop {
                font-weight: 400;
                font-size: 14px;
                color: #718096;
                // line-height: 22px;
                margin-bottom: 16px;
            }

            .nubs {
                display: flex;
                justify-content: space-between;

                .zongnub {
                    font-weight: bold;
                    font-size: 32px;
                    color: #111827;

                    // line-height: 40px;
                    .zongbai {
                        font-weight: 500;
                        font-size: 12px;
                        color: #3F8CFF;
                        margin-top: 5px;
                    }
                }
            }
        }

        :last-child {
            margin-right: 0;
        }
    }
}

.fenlist {

    margin-top: 20px;
    display: flex;
    // justify-content: space-between;
    height: calc(100% - 144px - 43px - 20px - 60px);

    .jilulist {
        width: calc(100% - 367px);
        max-width: 800px;
        height: 100%;
        background: #FFFFFF;
        border-radius: 8px;
        margin-right: 20px;
        padding: 24px 30px 0 26px;
        box-sizing: border-box;

        .jitop {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .jitopa {
                font-weight: 400;
                font-size: 16px;
                color: #111827;
            }

            .jitopb {
                font-weight: 400;
                font-size: 14px;
                color: #3F8CFF;
            }


        }
    }

    .pailist {
        width: 367px;
        height: 100%;
        background: #FFFFFF;
        border-radius: 8px;
        padding: 24px 24px 0 25px;
        box-sizing: border-box;
        position: relative;

        .jitop {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .jitopa {
                font-weight: 400;
                font-size: 16px;
                color: #111827;
            }

            .jitopb {
                font-weight: 400;
                font-size: 14px;
                color: #3F8CFF;
                cursor: pointer;
            }

        }

        .paixi {
            position: absolute;
            width: 322px;
            height: 62px;
            border-top: 1px solid #EEEFF2;
            bottom: 0px;
            line-height: 62px;
            text-align: center;
            font-weight: 400;
            font-size: 14px;
            color: #3F8CFF;
            cursor: pointer;
        }

        td {
            border-top: 1px solid #EEEFF2;
        }
    }
}

.riperpo {

    width: 100%;
    margin-top: 21px;
    font-size: 14px;

    table {
        width: 100%;
        border-spacing: 0;

        thead {
            width: 100%;
            height: 46px;
            line-height: 46px;
            font-weight: 400;
            font-size: 12px;
            color: #4D585F;

            th:first-child {
                text-align: left;
            }

            th {
                text-align: left;
                background-color: #FAFAFA;

            }

            :first-child {
                padding-left: 24px;
                border-radius: 8px 0 0 8px;
                box-sizing: border-box;

            }

            :last-child {
                border-radius: 0 8px 8px 0;

            }

        }

        tbody {

            width: 100%;

            tr {
                width: 100%;
                text-align: center;
                font-weight: 400;
                color: #718096;
                border-bottom: 1px solid #E9E9E9;

                .libaomm {
                    display: flex;
                    align-items: center;
                    height: 101px;

                    .mmimg {
                        width: 56px;
                        height: 56px;
                        border-radius: 8px;
                        overflow: hidden;

                        img {
                            width: 100%;
                            height: 100%;
                        }
                    }

                    .libaomms {
                        height: 46px;
                        // display: flex;
                        // flex-direction: column;
                        // justify-content: space-between;
                        margin-left: 10px;

                        .imgname {
                            margin-right: 5px;
                            width: 170px;
                            // height: 60px;
                            font-size: 14px;
                            color: #111827;
                            line-height: 14px;

                            overflow: hidden;
                            white-space: wrap;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-line-clamp: 2;
                            /* 显示两行 */
                            -webkit-box-orient: vertical;
                            // white-space: nowrap;
                        }

                        .imngnub {
                            font-size: 14px;
                            color: #718096;
                            line-height: 18px;

                        }
                    }
                }

                td {
                    height: 60px;
                    font-weight: 400;
                    font-size: 12px;
                    color: #000000;

                    vertical-align: middle;
                    text-align: left;
                }




            }
        }
    }

}
</style>